"use client";

import dynamic from "next/dynamic";
import { useEffect, useState, useRef } from "react";
import { cn } from "@/lib/utils";

const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

export const FirstScreen = () => {
  return (
    <div className="relative flex justify-center">
      {/* 全宽背景层 - 覆盖整个视口宽度 */}
      <div
        className="fixed top-0 left-0 w-screen h-screen bg-gradient-to-br from-sky-200 to-purple-100 -z-10"
        style={{
          width: "100vw",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      />

      <div className="w-[1920px] h-screen bg-gradient-to-br from-sky-200 to-purple-100 z-[1] flex flex-col pt-[150px] relative">
        <div className="w-[37.75rem] h-[37.75rem]   absolute top-[30px] right-[13rem] z-100 ">
          <EarthAnimation />
        </div>
        <div className="w-full h-screen   pl-[12rem] pr-[13rem] z-[3] pb-2.5 absolute flex  ">
          <div className="flex-1 ">
            <div>
              <div className="w-96 px-2.5 py-1 bg-gradient-to-r from-[#619BFF] to-[#C6E1FF] rounded-[10px] inline-flex justify-start items-center mr-[12px]">
                <div className=" h-12 justify-start text-white text-2xl font-normal font-['Alibaba_PuHuiTi_3.0'] leading-[50px]">
                  热门海外产品丨了解详情
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  className="mt-[5px]"
                >
                  <path
                    d="M11.1133 6.43457L21.6433 6.43457V16.9646"
                    stroke="white"
                    stroke-width="2.34"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6.75391 21.3263L21.6455 6.43457"
                    stroke="white"
                    stroke-width="2.34"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="w-[749px] mt-[20px] h-[75px] justify-start text-[#0182FF] text-4xl font-medium font-['Alibaba_PuHuiTi_3.0'] leading-[75px]">
                网络解决方案引领者 赋能品牌出海新纪元
                <br />
              </div>
              <div className="w-[766px] h-28 justify-start text-blue-950 text-6xl font-bold font-['Alibaba_PuHuiTi_3.0'] leading-[112px]">
                光年无界一站式出海服务
                <br />
              </div>
              <div className="inline-flex justify-start items-center gap-7">
                <a
                  href="https://t22qshgkpd.jiandaoyun.com/f/68cb68e880eabb692970b84a"
                  target="_blank"
                  className="w-44 h-14 px-6 py-2.5 bg-gradient-to-r from-[#5F97FF] to-[#0182FF] rounded-[9.60px] flex justify-center items-center gap-1 cursor-pointer"
                >
                  <div className="justify-start text-white text-2xl font-medium font-['Alibaba_PuHuiTi_3.0']">
                    立即购买
                  </div>
                </a>
                <a
                  target="_blank"
                  href="https://www.guangnianwujie.com/client/gnchgj-win.exe"
                  className="w-44 h-14 px-6 py-2.5 rounded-[9.60px] outline outline-1 outline-offset-[-1px] outline-[#0182FF] flex justify-center items-center gap-1 cursor-pointer"
                >
                  <div className="justify-start text-blue-600 text-2xl font-medium font-['Alibaba_PuHuiTi_3.0']">
                    点击下载
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1" />
        <EcommerceLoop />
        <div className="h-[30px]" />
      </div>
    </div>
  );
};

// Lazy load earth animation with seamless transition
const EarthAnimation = () => {
  const [animationData, setAnimationData] = useState<any>(null);
  const [loadingAn, setLoadingAn] = useState(true);

  useEffect(() => {
    // Load animation data only when component mounts
    import("public/animation/earth.json")
      .then((data) => {
        setAnimationData(data.default);
        // 延迟一点时间确保动画准备就绪
        setTimeout(() => {
          setLoadingAn(false);
        }, 100);
      })
      .catch(() => {
        setLoadingAn(false);
      });
  }, []);

  return (
    <div className="w-[37.75rem] h-[37.75rem] relative overflow-hidden ">
      {/* 图片占位符 - 使用相同的 transform */}
      <img
        src="/imgs/home/first-earth.png"
        alt="地球动画占位图"
        width={604}
        height={604}
        className={cn(
          "w-full h-full object-contain absolute top-0 left-0 transition-opacity duration-300",
          !loadingAn && "opacity-0"
        )}
        style={{
          transform: "scale(0.8)",
        }}
      />

      {/* Lottie 动画 */}
      {animationData && (
        <Lottie
          animationData={animationData}
          loop={true}
          style={{
            width: "37.75rem",
            height: "37.75rem",
            transform: "scale(1.6)",
          }}
          className={cn(
            "w-full h-full object-contain absolute top-0 left-0 transition-opacity duration-300",
            loadingAn && "opacity-0"
          )}
        />
      )}
    </div>
  );
};

const EcommerceLoop = () => {
  const [containerWidth, setContainerWidth] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<HTMLDivElement>(null);
  const animationIdRef = useRef<number | null>(null);
  const [isPaused, setIsPaused] = useState(false);
  const positionRef = useRef(0); // 保存当前位置
  const lastTimestampRef = useRef<number | null>(null); // 保存上次时间戳

  const logos: { src: string }[] = [
    {
      src: "/ecommerce/alibaba.png",
    },
    {
      src: "/ecommerce/aliexpress.png",
    },
    {
      src: "/ecommerce/amazon.png",
    },
    {
      src: "/ecommerce/coupang.png",
    },
    {
      src: "/ecommerce/daraz.png",
    },
    {
      src: "/ecommerce/ebay.png",
    },
    {
      src: "/ecommerce/etsy.png",
    },
    {
      src: "/ecommerce/fnac.png",
    },
    {
      src: "/ecommerce/googleads.png",
    },
    {
      src: "/ecommerce/lazada.png",
    },
    {
      src: "/ecommerce/linked.png",
    },
    {
      src: "/ecommerce/mercado.png",
    },
    {
      src: "/ecommerce/mercari.png",
    },
    {
      src: "/ecommerce/ozon.png",
    },
    {
      src: "/ecommerce/shein.png",
    },
    {
      src: "/ecommerce/shopee.png",
    },
    {
      src: "/ecommerce/shopify.png",
    },
    {
      src: "/ecommerce/temu.png",
    },
    {
      src: "/ecommerce/tiktoklive.png",
    },
    {
      src: "/ecommerce/tiktokshop.png",
    },
    {
      src: "/ecommerce/wayfair.png",
    },
    {
      src: "/ecommerce/walmart.png",
    },
    {
      src: "/ecommerce/wordpress.png",
    },
  ];

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        setContainerWidth(width);
      }
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  useEffect(() => {
    const speed = 0.1; // 像素/毫秒
    const totalWidth = containerWidth * 2; // 两组图片的总宽度

    const animate = (timestamp: number) => {
      if (lastTimestampRef.current === null) {
        lastTimestampRef.current = timestamp;
      }

      if (!isPaused) {
        const deltaTime = timestamp - lastTimestampRef.current;
        positionRef.current += speed * deltaTime;

        // 循环逻辑：当超过总宽度时重置
        if (positionRef.current >= totalWidth) {
          positionRef.current = 0;
        }

        if (animationRef.current) {
          animationRef.current.style.transform = `translateX(-${positionRef.current}px)`;
        }
      }

      lastTimestampRef.current = timestamp;
      animationIdRef.current = requestAnimationFrame(animate);
    };

    animationIdRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationIdRef.current) {
        cancelAnimationFrame(animationIdRef.current);
      }
    };
  }, [containerWidth, isPaused]);

  const handleMouseEnter = () => {
    setIsPaused(true);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
  };

  return (
    <div
      ref={containerRef}
      className="w-full h-[50px] z-[5] overflow-hidden relative"
      style={{ minWidth: "100%" }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* 无限滚动容器 */}
      <div
        ref={animationRef}
        className="flex items-center"
        style={{
          width: "max-content",
          willChange: "transform",
        }}
      >
        {/* 第一组图片 */}
        <div className="flex items-center space-x-8 whitespace-nowrap">
          {logos.map((logo, index) => (
            <img
              key={`first-${index}`}
              className="w-[250px] h-[50px] object-contain flex-shrink-0"
              src={logo.src}
            />
          ))}
        </div>

        {/* 第二组图片（无缝循环） */}
        <div className="flex items-center space-x-8 whitespace-nowrap ml-8">
          {logos.map((logo, index) => (
            <img
              key={`second-${index}`}
              className="w-[250px] h-[50px] object-contain flex-shrink-0"
              src={logo.src}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
